import React from 'react';
import { RejectCodeConfigurationCard } from '@europrocurement/flexy-components';
import { Grid } from '@mui/material';
import { CodeRejet, useAchatsService, useSociete } from '@europrocurement/l2d-domain';
import { useRejectCodeUtils } from '../../../../hooks/rejectCodeHooks';

const ConfigurationRow: React.FunctionComponent = function () {
    const { codeRejetApi } = useAchatsService();

    const {
        methods: { reloadRejectCode },
        rejectCode,
    } = useRejectCodeUtils();

    const xIdSociete = useSociete();

    const updateRejectCodeManual = async () => {
        if (!rejectCode.code) {
            return;
        }

        await codeRejetApi.patchCodeRejetItem({
            code: rejectCode.code,
            codeRejetCodeRejetUpdate: {
                manuel: !rejectCode.manuel,
            },
            xIdSociete,
        });

        reloadRejectCode();
    };

    const updateRejectCodeBlocked = async () => {
        if (!rejectCode.code) {
            return;
        }

        await codeRejetApi.patchCodeRejetItem({
            code: rejectCode.code,
            codeRejetCodeRejetUpdate: {
                bloquant: !rejectCode.bloquant,
            },
            xIdSociete,
        });

        reloadRejectCode();
    };

    const updateRejectCodeAutoFollowUp = async () => {
        if (!rejectCode.code) {
            return;
        }

        await codeRejetApi.patchCodeRejetItem({
            code: rejectCode.code,
            codeRejetCodeRejetUpdate: {
                relanceAuto: !rejectCode.relanceAuto,
            },
            xIdSociete,
        });

        reloadRejectCode();
    };

    const changeCodeRejetsConfigurationAction = (field: keyof CodeRejet) => {
        switch (field) {
            case 'manuel':
                return updateRejectCodeManual();
            case 'bloquant':
                return updateRejectCodeBlocked();
            case 'relanceAuto':
                return updateRejectCodeAutoFollowUp();
            default:
                throw new Error(`Error field to change not found ${field}`);
        }
    };

    return (
        <Grid
            item
            xs={12}
        >
            <RejectCodeConfigurationCard
                rejectCode={rejectCode}
                changeConfiguration={changeCodeRejetsConfigurationAction}
            />
        </Grid>
    );
};

export default ConfigurationRow;
